import React from "react";
import { checkAllForSearch } from "slices/discovery/actions/theme";
import {
  uncheckAllThemes,
  collapseAllThemes,
} from "slices/discovery/discoverySlice";

import { useDispatch, useSelector } from "react-redux";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import ButtonsDropdownOption from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdownOption";
import { buttonVariants } from "@visiblethread/react-components/dist/components/Button";
import threeDotsIcon from "icons/three_dots_purple.svg";
import { filterThemes } from "utils/discovery";
import { getCheckedNPs } from "../helpers";

const CategoriesDropdown = () => {
  const allThemes = useSelector((state) => state.discovery.themes);
  const themes = allThemes.filter((t) => t.GroupName !== "All Themes");
  const isSearch = useSelector((state) => state.discovery.config.isSearch);
  const showAll = useSelector((state) => state.discovery.config.showAll);
  const filterView = useSelector((state) => state.discovery.config.filterView);
  const checkedNPs = getCheckedNPs(themes, isSearch, filterView, showAll);
  const isThemeChecked = checkedNPs.length !== 0;
  const isThemeExpanded = themes.some((element) => element.collapsed === false);
  const dispatch = useDispatch();

  const dispatchUncheckAll = () => {
    dispatch(uncheckAllThemes());
  };

  const dispatchCollapseAll = () => {
    dispatch(collapseAllThemes());
  };

  const dispatchCheckAllForSearch = () => {
    dispatch(checkAllForSearch(themes));
  };

  const renderOptions = () => {
    const options = [];

    options.push(
      <ButtonsDropdownOption
        content="Uncheck all"
        onClick={dispatchUncheckAll}
        disabled={!isThemeChecked}
      />
    );

    options.push(
      <ButtonsDropdownOption
        content="Collapse all"
        onClick={dispatchCollapseAll}
        disabled={!isThemeExpanded}
      />
    );

    if (isSearch) {
      options.push(
        <ButtonsDropdownOption
          content="Check all"
          onClick={dispatchCheckAllForSearch}
        />
      );
    }

    return options;
  };

  return (
    <div className="themes__dropdown">
      <Dropdown
        type={dropdownTypes.buttons}
        propsObject={{
          button: <img src={threeDotsIcon} alt="three-dots" />,
          options: renderOptions(),
          hideArrowIcon: true,
          buttonVariant: buttonVariants.borderless,
        }}
      />
    </div>
  );
};

export default CategoriesDropdown;
